import InfiniteLoad from './components/infiniteLoad';
import { mergeObject } from './helper/helper';

($ => {
	const loadMore = $('#hpy_load_more');
	if (loadMore.length) {
		new InfiniteLoad({
			trigger: '#hpy_load_more',
			wrap: loadMore.data('wrap'),
			data:
				mergeObject(
					{
						action: 'hpy_load_more',
						nonce: hpyInfinite.nonce
					},
					loadMore.data()
				),

			continue: true
		});
	}
})(jQuery);